'use client';

import _slicedToArray from "/codebuild/output/src1641/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
import { autoUpdate } from '@floating-ui/react';
import { useDidUpdate } from '@mantine/hooks';
function useFloatingAutoUpdate(_ref) {
  var opened = _ref.opened,
    floating = _ref.floating,
    position = _ref.position,
    positionDependencies = _ref.positionDependencies;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    delayedUpdate = _useState2[0],
    setDelayedUpdate = _useState2[1];
  useEffect(function () {
    if (floating.refs.reference.current && floating.refs.floating.current) {
      return autoUpdate(floating.refs.reference.current, floating.refs.floating.current, floating.update);
    }
    return void 0;
  }, [floating.refs.reference.current, floating.refs.floating.current, opened, delayedUpdate, position]);
  useDidUpdate(function () {
    floating.update();
  }, positionDependencies);
  useDidUpdate(function () {
    setDelayedUpdate(function (c) {
      return c + 1;
    });
  }, [opened]);
}
export { useFloatingAutoUpdate };